import { Box, Typography } from '@mui/material';
import Gift from '../../../assets/images/icons/gift_white.png';
import RegisterLayout from '../../../components/layouts/RegisterLayout';
import AppButton from '../../../components/ui/AppButton';
import useCountdown from '../../../hooks/useCountdown';
import RegisterCountDown from './RegisterCountdown';
import RegisterOtpInput from './RegisterOtpInput';

const DURATION_MS = 120_000; // 2 minutes

const RegisterOTP = ({ onBack, onResend, onVerify, isLoading }) => {
  const { minutes, seconds, isFinished, reset } = useCountdown(DURATION_MS);

  const handleResend = () => {
    reset();
    onResend();
  };

  return (
    <RegisterLayout>
      {/* Main */}
      <Box sx={{ minHeight: '600px', overflow: 'auto', py: 3.75, px: 2 }}>
        <Typography
          component="h1"
          sx={{
            fontSize: '2.5rem',
            fontWeight: 700,
            color: '#005972',
            textAlign: 'center',
            mb: 2.5,
          }}
        >
          สมัครสมาชิก
        </Typography>
        <RegisterOtpInput onVerify={onVerify} isLoading={isLoading} />
        <Box>
          {!isFinished && (
            <Typography
              sx={{
                fontSize: '1.5rem',
                lineHeight: 1,
                color: '#005972',
                textAlign: 'center',
                mt: 3.75,
                mb: 1.5,
              }}
            >
              รหัส OTP ไม่ถูกต้องกรุณากรอกใหม่อีกครั้ง
            </Typography>
          )}
          <Typography
            sx={{
              fontSize: '1.5rem',
              lineHeight: 1,
              color: '#005972',
              textAlign: 'center',
              mt: isFinished ? 3.75 : 0,
              mb: 2.5,
            }}
          >
            {isFinished ? (
              'รหัส OTP หมดอายุแล้ว กรุณาขอใหม่'
            ) : (
              <>
                เหลือเวลาอีก <RegisterCountDown minutes={minutes} seconds={seconds} /> นาที
              </>
            )}
          </Typography>
        </Box>
      </Box>

      {/* Footer */}
      <Box
        sx={{
          backgroundColor: '#E1000C',
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '50%',
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '10px',
            marginTop: '-40px',
            width: '100%',
            maxWidth: '450px',
            mx: 'auto',
          }}
        >
          <AppButton
            variant="registerDanger"
            fullWidth
            sx={{ width: '50%', maxWidth: '170px', height: '50px', border: '1px solid white' }}
            onClick={onBack}
          >
            แก้ไขเบอร์มือถือ
          </AppButton>
          <AppButton
            variant="registerPrimary"
            fullWidth
            sx={{ width: '50%', maxWidth: '170px', height: '50px', px: 0.5 }}
            onClick={handleResend}
            disabled={!isFinished || isLoading}
          >
            ขอรหัส OTP อีกครั้ง
          </AppButton>
        </Box>

        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <Typography
              sx={{ fontSize: '2rem', lineHeight: '1.75rem', fontWeight: '700', color: 'white' }}
            >
              สตาร์การ์ด คลับ 2026
            </Typography>
            <Box
              component={'img'}
              src={Gift}
              alt="Gift Icon"
              sx={{ width: '35px', marginTop: '-5px' }}
            />
          </Box>
          <Typography
            sx={{ fontSize: '1.25rem', lineHeight: '1.4rem', fontWeight: '500', color: 'white' }}
          >
            จากโรงกลั่น...สู่ธุรกิจคุณ
            <br />
            เปลี่ยนทุกลิตรเป็นคะแนน สะสมของรางวัลสุดคุ้ม
          </Typography>
        </Box>
      </Box>
    </RegisterLayout>
  );
};

export default RegisterOTP;
